import * as React from "react";
import { forwardRef } from "react";
const SvgCheckbox = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 19, height: 19, rx: 3.5, stroke: "#004269", strokeOpacity: 0.28 }));
const ForwardRef = forwardRef(SvgCheckbox);
export default ForwardRef;
